var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M4.992 8.5A1.497 1.497 0 1 1 2 8.5a1.497 1.497 0 1 1 2.992 0m5.493 0c0 .832-.661 1.5-1.485 1.5a1.486 1.486 0 0 1-1.477-1.5c0-.832.66-1.5 1.477-1.5.824 0 1.485.668 1.485 1.5M16 8.5c0 .832-.66 1.5-1.485 1.5a1.49 1.49 0 0 1-1.5-1.5c0-.832.662-1.5 1.5-1.5C15.34 7 16 7.668 16 8.5"
})));
export default SvgIconMore;